module.exports = {
	"classes": [
		"homepage-page",
		"header-dark"
	],
	"title": "Single Sign On & Token Based Authentication",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/jp/homepage/data/metadata.json
// module id = 1129
// module chunks = 0